/**
 * Links in Bereiche, die (noch) von der Legacy-Website bedient werden.
 *
 * Diese App läuft parallel zur Legacy-App auf derselben Domain; der Ingress
 * entscheidet pro Pfad, welche App antwortet (siehe docs/legacy-migration.md).
 * Ein normaler `<NuxtLink>` würde clientseitig innerhalb DIESER App navigieren
 * und dort eine 404-Seite zeigen — Links in Legacy-Pfade müssen deshalb
 * `external` sein (voller Seitenaufruf, damit der Ingress greift).
 *
 * VORMERKEN: Alle Verwendungen von `LEGACY_PATHS` sind solche Links
 * (`grep -rn LEGACY_PATHS app layers`). Wird ein Bereich in diese App
 * migriert, muss der jeweilige Pfad hier entfernt und der Link wieder zu einem
 * normalen internen Link (ohne `external`) werden.
 */
export const LEGACY_PATHS = {
  /** Startseite der Website (liegt noch in der Legacy-App). */
  home: '/',
} as const;
